import styled from 'styled-components'
import {
  getActivityActionBgColor,
  getActivityActionTextColor,
  getActivityBorderColor,
} from './util'
import { Typography } from 'components/Typography/Typography'

export const Container = styled.div`
  padding: 16px 0;
  margin-top: 32px;
  border-radius: 16px;
  border: 0.7px solid ${p => p.theme.colors.divider};
  background: ${p => p.theme.colors.background.primary};
  box-shadow: 0px 0px 16px 0px ${p => p.theme.colors.background.hover};
`

export const Title = styled(Typography)`
  padding: 0 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${p => p.theme.colors.text.primary};
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding-left: 16px;
    padding-right: 16px;
    font-size: ${p => p.theme.typography.size.Description}px;
  }
`

export const HeaderContainer = styled.div`
  padding: 16px 24px;
  display: flex;
  border-bottom: 1px solid ${p => p.theme.colors.divider};
  gap: 20px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding: 32px 16px;
    gap: 0;
    justify-content: space-between;
  }
`

export const Th = styled(Typography)`
  flex-basis: 200px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    font-size: ${p => p.theme.typography.size.Body}px;
  }
`

export const Td = styled(Typography)`
  flex-basis: 200px;
  height: 80px;
  display: flex;
  align-items: center;
`

export const Activity = styled.div<{ $type: string }>`
  padding: 4px 8px;
  border-radius: 4px;
  color: ${p => getActivityActionTextColor(p.$type, p.theme)};
  background-color: ${p => getActivityActionBgColor(p.$type, p.theme)};
  border: 1px solid ${p => getActivityBorderColor(p.$type, p.theme)};
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-right: auto;
  }
`

export const IconNextContainer = styled.div`
  display: flex;
  position: absolute;
  right: 24px;
  cursor: pointer;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    right: 16px;
  }
`

export const TxnLabelContainer = styled.div`
  display: flex;
  position: absolute;
  right: 36px;
  cursor: pointer;
`

export const EmptyTable = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  border-bottom: ${p => `1px solid ${p.theme.colors.divider}`};
`

export const RowWrapper = styled.a<{ $isLast?: boolean }>`
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  cursor: pointer;
  padding: 0 24px;
  border-bottom: ${p => (p.$isLast ? 'none' : `1px solid ${p.theme.colors.divider}`)};
  &:hover {
    background-color: ${p => p.theme.colors.background.active};
    & > div > svg > rect {
      fill: ${p => p.theme.colors.button.background};
    }
    & > div > svg > path {
      stroke: ${p => p.theme.colors.background.primary};
    }
  }
`

export const MobileRowWrapper = styled.div<{ $isLast?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-bottom: ${p => (p.$isLast ? 'none' : `1px solid ${p.theme.colors.divider}`)};
`

export const MenuItem = styled.div`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${p => p.theme.colors.divider};
  &:hover {
    background-color: ${p => p.theme.colors.background.hover};
  }
  font-size: 14px;
  font-weight: 400;
`

export const IconContainer = styled.div<{ $disabled?: boolean }>`
  cursor: ${p => (p.$disabled ? 'auto' : 'pointer')};
  ${p => p.$disabled && `pointer-events: none; opacity: 0.5;`}
`

export const ActivityHistoryFilterContainer = styled.div`
  width: 32px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    width: 24px;
  }
`
